import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const posHeaderSliceB2C = createSlice({
  name: "posHeaderB2C",
  initialState: {
    customer: null,
    contact: 0,
    BatchNo: 0,
    invo: 0,
    date: dayjs().startOf("day").format("YYYY-MM-DD HH:mm:ss"),
    dealer: null,
    outlet: null,
    deliveryDate: dayjs(),
    balance: 0,
    edit: false,
    salesBill: 0,
    user: null,
    creditLimit: 0,
    other: { Name: "" },
    otherMenuItems: [],
    orderNo: "",
    partyWiseRate: false,
    priceLevel: { id: 1, label: "A" },
    address: "",
    vatNo: "",
    taxEnabled: false,
    isCostShow: false,
    narration: "",
    sino: 0,
    cashRecievedOnEditMode: 0,
    receiptType: "",
    updateHold: false,
    holdBillSino: 0,
    holdedBillStatus: 0,
    oldBillData: [],
    kotDifferenciatedTableData: [],
    partyCrDr: "Dr",
    prevBill_partyCrDr: "",
    billTime: new Date().toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }),
  },
  reducers: {
    updateSelected: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetState: () => {
      // Reset the state to its initial/default values
      return {
        customer: null,
        contact: 0,
        BatchNo: 0,
        edit: false,
        // invo: 0,
        date: dayjs(),
        deliveryDate: dayjs(),
        // dealer: null,
        // outlet: null,
        balance: 0,
        holdBillSino: 0,
        holdedBillStatus: 0,
      };
    },
  },
});

export const { updateSelected, resetState } = posHeaderSliceB2C.actions;
export default posHeaderSliceB2C.reducer;
